<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>

    <Sheet.Body
      class="px-[26px]! pt-2 pb-[calc(env(safe-area-inset-bottom)+24px)]!"
    >
      <ProMembershipDetailsBody />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import ProMembershipDetailsBody from './ProMembershipDetailsBody.vue'

const { close } = useSheet()
</script>
